<template>
  <div class="verbal-identity-intro-content" id="identidade-verbal-introducao" data-search-anchor>
    <div class="verbal-identity-content">
      <h1 class="verbal-identity-title">{{ verbalIdentityTitle }}</h1>
      <div class="verbal-identity-description-content">        
        <p class="verbal-identity-description-paragraph">{{ verbalIdentityDescriptionParagraph1 }}</p>
        <p class="verbal-identity-description-paragraph">{{ verbalIdentityDescriptionParagraph2 }}</p>
        <p class="verbal-identity-description-paragraph">{{ verbalIdentityDescriptionParagraph3 }}</p>
      </div>
      
    </div>    
  </div>    
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import VerbalIdentityPageMixin from '@/mixins/verbal-identity-page-mixin'
import { VerbalIdentityPageStore } from '@/store/verbal-identity-page/verbal-identity-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class VerbalIdentityIntroSection extends Mixins(VerbalIdentityPageMixin) {
  verbalIdentityPageStore: PageStoreContract = getModule(VerbalIdentityPageStore, this.$store)


   get verbalIdentityTitle(): string {
    return this.getElementText(1, 0)
  }

  get verbalIdentityDescriptionParagraph1(): string {
    return this.getElementText(1, 1)
  }

  get verbalIdentityDescriptionParagraph2(): string {
    return this.getElementText(1, 2)
  }

  get verbalIdentityDescriptionParagraph3(): string {
    return this.getElementText(1, 3)
  }
 
  async getVerbalIdentityPage(): Promise<void> {
    await this.verbalIdentityPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.verbalIdentityPageStore.isLoading) {
      await this.getVerbalIdentityPage()
    }
  }
}
</script>

<style lang="scss">
.verbal-identity-intro-content {
  display: flex;
  align-items: center;  
  flex-direction: column;
  width: 100%;
}

.verbal-identity-content {  
  display: grid;
  grid-template-columns: 52% 48%;
  justify-content: space-between;    
  width: 1032px;
}

.verbal-identity-title {  
  font-size: 48px;
  font-weight: 400;
  line-height: 52px;
  letter-spacing: -0.01em;
  text-align: left;
  padding: 0 5rem 0 0rem;
  margin: 0;
  white-space: pre-line;
}

.verbal-identity-description-content {
  width: 514px;
}


.verbal-identity-description-paragraph {
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  white-space: pre ;
  
}

.verbal-identity-description-paragraph:first-of-type {
  margin-top: 0;
}

</style>

